export default {"src":"/_next/static/media/up_regular.df8f5114.svg","height":24,"width":24};